import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { StrategicAllyFilter } from '../../../../../shared/types/modules/strategicAlly';

export const useStrategicAllyFilters = (
    onFilter?: (data: StrategicAllyFilter) => void
) => {
    const { strategicAllyId } = useParams();

    const onSubmit = (data: StrategicAllyFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            strategicAllyId: strategicAllyId?.trim() || '',
        },
        onSubmit,
    });

    useEffect(() => {
        if (
            formik?.values?.strategicAllyId &&
            formik?.values?.strategicAllyId === strategicAllyId?.trim()
        ) {
            formik?.submitForm();
        }
    }, [strategicAllyId, formik?.values?.strategicAllyId]);

    return {
        formik,
    };
};
